/* eslint-disable */
// AUTO-GENERATED by scripts/codegen/generate.mjs from wix.isa.recipient.v1 — do not edit.

import { resolveUrl, toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
const _recipient = {
  createdDate: 'google.protobuf.Timestamp',
  updatedDate: 'google.protobuf.Timestamp'
};
const _createRecipientRequest = {
  recipient: '_recipient'
};
const _createRecipientResponse = {
  recipient: '_recipient'
};
const _getRecipientRequest = {};
const _getRecipientResponse = {
  recipient: '_recipient'
};
const _updateRecipientRequest = {
  recipient: '_recipient',
  fieldMask: 'google.protobuf.FieldMask'
};
const _updateRecipientResponse = {
  recipient: '_recipient'
};
const _boUpdateRecipientRequest = {
  recipient: '_recipient',
  fieldMask: 'google.protobuf.FieldMask'
};
const _boUpdateRecipientResponse = {
  recipient: '_recipient'
};
const _deleteRecipientRequest = {};
const _deleteRecipientResponse = {};
const _queryRecipientsRequest = {};
const _queryRecipientsResponse = {
  recipients: '_recipient'
};
const _getMyRecipientRequest = {};
const _getMyRecipientResponse = {
  recipient: '_recipient'
};
const _getOrCreateRecipientRequest = {};
const _getOrCreateRecipientResponse = {
  recipient: '_recipient'
};
const _associateMetaSiteIdsRequest = {};
const _associateMetaSiteIdsResponse = {
  recipient: '_recipient'
};
const _calculateCommunicationChannelRequest = {};
const _calculateCommunicationChannelResponse = {};
const _descriptors = {
  _recipient,
  _createRecipientRequest,
  _createRecipientResponse,
  _getRecipientRequest,
  _getRecipientResponse,
  _updateRecipientRequest,
  _updateRecipientResponse,
  _boUpdateRecipientRequest,
  _boUpdateRecipientResponse,
  _deleteRecipientRequest,
  _deleteRecipientResponse,
  _queryRecipientsRequest,
  _queryRecipientsResponse,
  _getMyRecipientRequest,
  _getMyRecipientResponse,
  _getOrCreateRecipientRequest,
  _getOrCreateRecipientResponse,
  _associateMetaSiteIdsRequest,
  _associateMetaSiteIdsResponse,
  _calculateCommunicationChannelRequest,
  _calculateCommunicationChannelResponse
};
function resolveRecipientServiceUrl(opts) {
  const domainToMappings = {
    'manage._base_domain_': [{
      srcPath: '/_api/recipient',
      destPath: ''
    }],
    'www.wixapis.com': [{
      srcPath: '/individual-scheduling-assistant/v1/recipients',
      destPath: '/v1/recipients'
    }],
    '*.dev.wix-code.com': [{
      srcPath: '/individual-scheduling-assistant/v1/recipients',
      destPath: '/v1/recipients'
    }],
    _: [{
      srcPath: '/individual-scheduling-assistant/v1/recipients',
      destPath: '/v1/recipients'
    }]
  };
  return resolveUrl(Object.assign(opts, {
    domainToMappings
  }));
}

/** CreateRecipient. */
export function createRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_createRecipientRequest, _descriptors);
  const fromRes = serializer(_createRecipientResponse, _descriptors).fromJSON;
  function __createRecipient(_ref) {
    let {
      host
    } = _ref;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'POST',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.CreateRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __createRecipient.fromReq = fromReq;
  __createRecipient.__isAmbassador = true;
  return __createRecipient;
}

/** GetRecipient. */
export function getRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getRecipientRequest, _descriptors);
  const fromRes = serializer(_getRecipientResponse, _descriptors).fromJSON;
  function __getRecipient(_ref2) {
    let {
      host
    } = _ref2;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'GET',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.GetRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/{recipient_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getRecipient.fromReq = fromReq;
  __getRecipient.__isAmbassador = true;
  return __getRecipient;
}

/** UpdateRecipient. */
export function updateRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_updateRecipientRequest, _descriptors);
  const fromRes = serializer(_updateRecipientResponse, _descriptors).fromJSON;
  function __updateRecipient(_ref3) {
    let {
      host
    } = _ref3;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'PATCH',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.UpdateRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/{recipient.id}',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __updateRecipient.fromReq = fromReq;
  __updateRecipient.__isAmbassador = true;
  return __updateRecipient;
}

/** BoUpdateRecipient. */
export function boUpdateRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_boUpdateRecipientRequest, _descriptors);
  const fromRes = serializer(_boUpdateRecipientResponse, _descriptors).fromJSON;
  function __boUpdateRecipient(_ref4) {
    let {
      host
    } = _ref4;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'PATCH',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.BoUpdateRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/bo/recipients/{recipient.id}',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __boUpdateRecipient.fromReq = fromReq;
  __boUpdateRecipient.__isAmbassador = true;
  return __boUpdateRecipient;
}

/** DeleteRecipient. */
export function deleteRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_deleteRecipientRequest, _descriptors);
  const fromRes = serializer(_deleteRecipientResponse, _descriptors).fromJSON;
  function __deleteRecipient(_ref5) {
    let {
      host
    } = _ref5;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'DELETE',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.DeleteRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/{recipient_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __deleteRecipient.fromReq = fromReq;
  __deleteRecipient.__isAmbassador = true;
  return __deleteRecipient;
}

/** QueryRecipients. */
export function queryRecipients(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_queryRecipientsRequest, _descriptors);
  const fromRes = serializer(_queryRecipientsResponse, _descriptors).fromJSON;
  function __queryRecipients(_ref6) {
    let {
      host
    } = _ref6;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'POST',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.QueryRecipients',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/query',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes,
      fallback: [{
        method: 'POST',
        url: resolveRecipientServiceUrl({
          protoPath: '/v1/recipients/query',
          data: serializedData,
          host
        }),
        data: serializedData
      }, {
        method: 'GET',
        url: resolveRecipientServiceUrl({
          protoPath: '/v1/recipients/query',
          data: serializedData,
          host
        })
      }]
    };
  }
  __queryRecipients.fromReq = fromReq;
  __queryRecipients.__isAmbassador = true;
  return __queryRecipients;
}

/** GetMyRecipient. */
export function getMyRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getMyRecipientRequest, _descriptors);
  const fromRes = serializer(_getMyRecipientResponse, _descriptors).fromJSON;
  function __getMyRecipient(_ref7) {
    let {
      host
    } = _ref7;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'POST',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.GetMyRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/get-mine',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __getMyRecipient.fromReq = fromReq;
  __getMyRecipient.__isAmbassador = true;
  return __getMyRecipient;
}

/** GetOrCreateRecipient. */
export function getOrCreateRecipient(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getOrCreateRecipientRequest, _descriptors);
  const fromRes = serializer(_getOrCreateRecipientResponse, _descriptors).fromJSON;
  function __getOrCreateRecipient(_ref8) {
    let {
      host
    } = _ref8;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'POST',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.GetOrCreateRecipient',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/get-or-create',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __getOrCreateRecipient.fromReq = fromReq;
  __getOrCreateRecipient.__isAmbassador = true;
  return __getOrCreateRecipient;
}

/** AssociateMetaSiteIds. */
export function associateMetaSiteIds(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_associateMetaSiteIdsRequest, _descriptors);
  const fromRes = serializer(_associateMetaSiteIdsResponse, _descriptors).fromJSON;
  function __associateMetaSiteIds(_ref9) {
    let {
      host
    } = _ref9;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'POST',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.AssociateMetaSiteIds',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/{recipient_id}/associate-meta-sites',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __associateMetaSiteIds.fromReq = fromReq;
  __associateMetaSiteIds.__isAmbassador = true;
  return __associateMetaSiteIds;
}

/** CalculateCommunicationChannel. */
export function calculateCommunicationChannel(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_calculateCommunicationChannelRequest, _descriptors);
  const fromRes = serializer(_calculateCommunicationChannelResponse, _descriptors).fromJSON;
  function __calculateCommunicationChannel(_ref0) {
    let {
      host
    } = _ref0;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.recipient',
      method: 'POST',
      methodFqn: 'wix.isa.recipient.v1.RecipientService.CalculateCommunicationChannel',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveRecipientServiceUrl({
        protoPath: '/v1/recipients/{recipient_id}/calculate-communication-channel',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __calculateCommunicationChannel.fromReq = fromReq;
  __calculateCommunicationChannel.__isAmbassador = true;
  return __calculateCommunicationChannel;
}
//# sourceMappingURL=recipientHttpRequests.js.map